module.exports = __webpack_public_path__ + "static/media/Rob Brantley.efaeea89.jpg";